module.exports = __webpack_public_path__ + "img/inactive-22.1220d604.svg";